import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import API from '../api';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useEventTracking } from '../hooks/useAnalytics';
import { SellerGridSkeleton } from '../components/skeleton';

// Frecce custom SVG (come StoreSlider)
const NextArrow = (props) => (
  <button {...props} className="store-slider-arrow next" aria-label="Avanti">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8 4l8 8-8 8" stroke="#c93249" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
  </button>
);
const PrevArrow = (props) => (
  <button {...props} className="store-slider-arrow prev" aria-label="Indietro">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M16 4l-8 8 8 8" stroke="#c93249" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
  </button>
);

const SellerGrid = () => {
  const { trackSellerView, trackEvent } = useEventTracking();
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStores = async () => {
      try {
        const res = await API.get('/seller');
        setStores(res.data.sellers || []);
        setLoading(false);
      } catch (err) {
        setError('Errore nel caricamento dei negozi');
        setLoading(false);
      }
    };
    fetchStores();
  }, []); // Rimossa la dipendenza l

  // Traccia la visualizzazione della griglia venditori quando i dati sono caricati
  useEffect(() => {
    if (!loading && stores.length > 0) {
      trackEvent('seller_grid_view', {});
    }
  }, [loading, stores.length, trackEvent]);

  // 10 negozi più recenti (id più alto)
  const recentStores = [...stores]
    .sort((a, b) => b.id - a.id)
    .slice(0, 10);

  // Tutti gli altri negozi, esclusi i recenti, ordinati alfabeticamente
  const recentIds = new Set(recentStores.map(s => s.id));
  const alphabeticalStores = stores
    .filter(s => !recentIds.has(s.id))
    .sort((a, b) => (a.store_name || '').localeCompare(b.store_name || '', undefined, { sensitivity: 'base' }));

  // Slider settings (come StoreSlider)
  const sliderSettings = {
    dots: false,
    infinite: recentStores.length > 6,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 6,
    arrows: true,
    nextArrow: <NextArrow />, 
    prevArrow: <PrevArrow />, 
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };

  if (loading) {
    return <SellerGridSkeleton />;
  }

  if (error) {
    return (
      <div className="store-slider-empty">
        <p className="store-slider-empty-text">{error}</p>
      </div>
    );
  }

  return (
    <div className="main-content-container seller-grid-page">
      <h1 className="seller-grid-title">Tutti i Negozi</h1>

      <div className="seller-grid-section">
        <div className="seller-grid-section-header">
          <h3 className="seller-grid-section-title">Negozi recenti</h3>
        </div>
        <div className="store-slider-wrapper">
          <Slider {...sliderSettings}>
            {recentStores.map((store) => (
              <div key={store.id} className="store-card-custom">
                <Link 
                  to={`/seller/${store.seller_handle}`} 
                  className="store-card-link"
                  onClick={() => trackSellerView(store)}
                >
                  <div className="store-card-inner-custom">
                    <div className="store-logo-container-custom">
                      <img
                        src={store.store_logo_square || '/placeholder-store.jpg'}
                        alt={store.store_name}
                        className="store-logo-custom"
                      />
                    </div>
                    <div className="store-info-custom">
                      <span className="store-name-custom">{store.store_name}</span>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </Slider>
        </div>
      </div>

      <div className="seller-grid-section">
        <div className="seller-grid-section-header">
          <h3 className="seller-grid-section-title">Tutti i negozi</h3>
        </div>
        <div className="seller-grid-grid">
          {alphabeticalStores.map((store) => (
            <div key={store.id} className="store-card-custom">
              <Link 
                to={`/seller/${store.seller_handle}`} 
                className="store-card-link"
                onClick={() => trackSellerView(store)}
              >
                <div className="store-card-inner-custom">
                  <div className="store-logo-container-custom">
                    <img
                      src={store.store_logo_square || '/placeholder-store.jpg'}
                      alt={store.store_name}
                      className="store-logo-custom"
                    />
                  </div>
                  <div className="store-info-custom">
                    <span className="store-name-custom">{store.store_name}</span>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SellerGrid; 